// TODO: either find a better way to contruct this or move this into a utils
export const makeFirestoreFileUrl = (path: string): string => {
    return `https://firebasestorage.googleapis.com/v0/b/${process.env.REACT_APP_FIREBASE_PROJECT_ID}.appspot.com/o/${encodeURIComponent(path)}?alt=media`
}

export default makeFirestoreFileUrl;